import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import styles from './Layout.module.css';
import { useUser } from '../../context/UserContext';
import { supabase } from '../../config/supabase';
import { usePageTitle } from '../../hooks/usePageTitle';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { selectedApp, selectApp } = useUser();
  usePageTitle();

  const handleLogout = async () => {
    try {
      // Sign out from Supabase
      await supabase.auth.signOut();
      
      // Clear localStorage tokens
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('mongoToken');
      
      // Navigate to login page
      navigate('/login');
    } catch (error) {
      console.error('Error during logout:', error);
      // Still clear tokens and navigate even if there's an error
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('mongoToken');
      navigate('/login');
    }
  };

  const handleSwitchApp = () => {
    selectApp(null);
    navigate('/');
  };

  // Don't show nav for login/register pages
  const showNav = token && !location.pathname.match(/\/(login|register)$/);

  return (
    <div className={styles.layout}>
      {showNav && (
        <nav className={styles.nav}>
          <div className={styles.logo} onClick={() => navigate('/')}>
            TextLy
          </div>
          <div className={styles.navLinks}>
            <button onClick={() => navigate('/')} className={styles.navLink}>
              Dashboard
            </button>
            {selectedApp && (
              <button onClick={handleSwitchApp} className={styles.switchBtn}>
                 <img src="/assets/images/swapicon.png" alt="swap" className={styles.swapIcon} />
                 Switch App
              </button>
            )}
            <button onClick={handleLogout} className={styles.logoutButton}>
              Logout
            </button>
          </div>
        </nav>
      )}
      <main className={`${styles.main} bg-main`}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout; 